import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const AnalyticsBarChart = ({
  dataset,
  dataLabelKey = 'label',
  dataKey = 'value',
  name,
  width = '100%',
  height = '100%',
  minWidth = 300,
  minHeight = 300,
  fill,
  stroke,
}) => {
  if (!dataset || !dataset.length) {
    return null;
  }

  const values = dataset.map((i) => i.value);
  const maxValue = Math.max(...values);
  const minValue = Math.min(...values);

  const diff = maxValue - minValue;
  let minY = minValue - diff;
  if (minValue < 0) {
    minY = 0;
  }

  return (
    <ResponsiveContainer
      width={width}
      height={height}
      minWidth={minWidth}
      minHeight={minHeight}
    >
      <BarChart
        width={minWidth}
        height={minHeight}
        data={dataset}
        margin={{
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataLabelKey} />
        <YAxis domain={[minY, 'auto']} />
        <Tooltip />
        <Legend />
        <Bar name={name} dataKey={dataKey} fill={fill} stroke={stroke} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AnalyticsBarChart;
